export enum RuntimeVariables {
    Today = 0, // TODO: attenzione, in questo caso occorre indicare l'offset e non utilizzare l'ora
    CurrentUser = 1
}